import { createSlice } from '@reduxjs/toolkit';

const permissionSlice = createSlice({
  name: 'permission',
  initialState: {
    permissions: [],
    roles: [],
    loading: false,
  },
  reducers: {
    setPermissions: (state, action) => {
      state.permissions = action.payload;
    },
    setRoles: (state, action) => {
      state.roles = action.payload;
    },
    clearPermissions: (state) => {
      state.permissions = [];
      state.roles = [];
    },
  },
});

export const { setPermissions, setRoles, clearPermissions } = permissionSlice.actions;
export default permissionSlice.reducer;
